// extracted by mini-css-extract-plugin
export var arrow = "_d5-1";
export var content = "_d5-0";
export var highlighted = "_d5-2";